
  import Vue from 'vue'
  import FilterChipTemplate from './FilterChipTemplate.vue';
  import ConnectorService from '@/services/ConnectorService';
  import { autoComplete } from '@/utils/Util';

  export default Vue.extend({
    name: 'ConnectorFilter',

    components: {
      FilterChipTemplate
    },
    props: ['value', 'label', 'attributes', 'mandatory', 'always', 'multi', 'small'],
    data: (_this: any): any => ({
      rules: [
        (v: any) => !!v || _this.requiredError
      ],
      localConnector: _this.value[_this.attributes['value']],
      localFilters: _this.value as any,
      localTenantId: _this.$root.$store.state.session.selectedTenant.uuid,
      menu: false,
      loading: false,
      connectors: [],
    }),
    created() {
      this.getConnectors();
    },
    methods: {
      onSave() {
        this.localFilters[this.attributes['value']] = this.localConnector;
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onReset() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onChipRemove() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.$emit('delete');
      },
      autoComplete,
      getConnectors() {
        this.connectors = [];
        this.loading = true;

        ConnectorService.getAllCollectionPages(this.localTenantId).then((connectors: any[]) => {
          this.loading = false;

          this.connectors = connectors;
        }).catch((err: any) => {
          console.log(err, err.response);  
          this.loading = false;    
        });
      },
    },
    watch: {
      value() {
        this.localFilters = { ...this.value };
        this.localConnector = this.localFilters[this.attributes['value']];

        if('tenant' in this.localFilters && this.localFilters.tenant !== this.localTenantId) {
          this.localTenantId = this.localFilters.tenant;
          this.$delete(this.localFilters, this.attributes['value']);
          this.$emit('input', { ...this.localFilters });
          this.getConnectors();
        }
      },
      menu() {
        if(!this.menu) {
          this.localConnector = this.localFilters[this.attributes['value']];
        }
      },
      currentTenant() {
        this.localTenantId = this.currentTenant;
        this.connectors = [];
        this.localFilters = { ...this.value }; // TODO
        this.getConnectors();
      }
    },
    computed: {
      isValid(): any {
        return this.mandatory ? this.rules.reduce((acc: boolean, rule: any) => acc ? rule(this.localConnector)===true : acc, true) : true;
      },
      requiredError(): any {
        return this.$t('required');
      },
      filterRepr(): any {
        const raw = this.localFilters[this.attributes['value']];
        if (!raw) return '';
        if(this.multi) {
          return (raw as any[]).map((uuid: any) => {
            const found = this.connectors.find((c: any) => c.uuid === uuid);
            return found ? found.name : uuid;
          }).join(', ');
        }
        const found = this.connectors.find((c: any) => c.uuid === raw);
        return found ? found.name : raw;
      },
      currentTenant(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
    }
  })
